/**
 * Reading Room variant — barrel.
 *
 * Every variant exports:
 *  - `Hub`       — the home screen for this variant
 *  - `Trivia`    — the trivia renderer (consumes `games/trivia/engine.ts`)
 *  - `manifest`  — a small descriptor used by the variant selector in App.tsx
 *
 * Other surfaces (Affirmation, Celebration, CategoryMotif, palette, motion,
 * sound, categories) are internal to the variant — callers outside the
 * variant should not depend on them directly.
 */

export { Hub } from './Hub';
export { Trivia } from './Trivia';
export type { ReadingRoomTriviaProps } from './Trivia';

export interface VariantManifest {
  slug: string;
  title: string;
}

export const manifest: VariantManifest = {
  slug: 'reading-room',
  title: 'The Reading Room',
};
